import {
  IThreeLayerID,
  IR2PathsWithScript,
  IEntityBase,
  IMetadata,
  IScriptParams,
  ITriggerJavaData,
  ITriggerWebConfig
} from '../types/base';
import { IOwnership } from '../types/ownership';
import { IVisibilityChild } from '../types/visibility';
import { IFork } from '../types/fork';
import { IVersionLeaf } from '../types/version';
import { IPermissionData, IInjectConfig } from '../types/permission';
import { ulid } from 'ulid';
import { createMergeToDefaultData } from '../utils/mergeToDefaultData';

/**
 * 触发器接口（泛型版本）
 * 对应SQL表：project_trigger
 * 对应Go结构：ProjectTrigger
 */
export interface ITrigger<
  TJavaData extends ITriggerJavaData = ITriggerJavaData,
  TWebConfig extends ITriggerWebConfig = ITriggerWebConfig
> extends
  IThreeLayerID,
  IEntityBase,
  IR2PathsWithScript,
  IOwnership,
  IVisibilityChild,
  IFork,
  IVersionLeaf,
  IMetadata,
  IScriptParams<TJavaData, TWebConfig>
{
  type:string
  permissions?: IPermissionData[];    // 权限列表
  injects?: IInjectConfig[];          // 注入配置列表
}

// 向后兼容的默认类型
export type ITriggerDefault = ITrigger<ITriggerJavaData, ITriggerWebConfig>;

// === 类型常量 ===
export const triggerType = 'trigger'

// === Trigger Utils ===
function createDefaultTrigger(): ITrigger {
  return {
    ulid: ulid(),
    uuid: '',
    type:'',
    ownerUuid: '',
    currentVersion: 1,
    permissions: [],
    injects: [],
    createdAt: Date.now(),
    updatedAt: Date.now(),
    authorUuid: ''
  } as ITrigger
}

export interface ITriggerBaseUtils {
  type: string
  createDefaultData: () => ITrigger
  mergeDataToDefaultData: (data: Partial<ITrigger>) => ITrigger
}

export const triggerBaseUtils: ITriggerBaseUtils = {
  type: triggerType,
  createDefaultData: createDefaultTrigger,
  mergeDataToDefaultData: createMergeToDefaultData(createDefaultTrigger)
}
